import { action } from "typesafe-actions";
import { ThunkAction } from "redux-thunk";
import { IStoreState } from "../../initialStoreState";
import { AnyAction } from "redux";
import { api } from "../../../api/api";
import {
  saveLoaderCompleted,
  saveLoaderProgress,
  showMessage,
} from "../../messages/messagesActions";
import {
  ILifeInsuranceRiders,
  defaultLifeInsuranceRidersState,
} from "./lifeInsuranceRiders.types";
import { getUniqueId } from "../../../helpers";

export const FETCH_LIFE_INSURANCE_RIDERS_PROGRESS =
  "FETCH_LIFE_INSURANCE_RIDERS_PROGRESS";
export const FETCH_LIFE_INSURANCE_RIDERS_SUCCESS =
  "FETCH_LIFE_INSURANCE_RIDERS_SUCCESS";
export const FETCH_LIFE_INSURANCE_RIDERS_FAILED =
  "FETCH_LIFE_INSURANCE_RIDERS_FAILED";
export const CLEAR_LIFE_INSURANCE_RIDERS_STATE =
  "CLEAR_LIFE_INSURANCE_RIDERS_STATE";

export const fetchLifeInsuranceRidersProgress = () =>
  action(FETCH_LIFE_INSURANCE_RIDERS_PROGRESS);
export const fetchLifeInsuranceRidersSuccess = (data: ILifeInsuranceRiders) =>
  action(FETCH_LIFE_INSURANCE_RIDERS_SUCCESS, { data });
export const fetchLifeInsuranceRidersFailed = (errorMessage: string) =>
  action(FETCH_LIFE_INSURANCE_RIDERS_FAILED, { errorMessage });
export const clearLifeInsuranceRidersState = () =>
  action(CLEAR_LIFE_INSURANCE_RIDERS_STATE);

export const fetchLifeInsuranceRidersAsync =
  (customerPolicyId: number, customerId: number): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      dispatch(fetchLifeInsuranceRidersProgress());
      const res = await api.get(
        `/policy/get-riders?customer_policy_id=${customerPolicyId}&customer_id=${customerId}`
      );
      const data = res.data.data;
      if (data.length > 0) {
        const riders = data.map(
          (row: { incremental_number: number; rider: string | null; limit: string | null }) => ({
            ...row,
            key: getUniqueId(),
          })
        );
        dispatch(
          fetchLifeInsuranceRidersSuccess({
            customer_policy_id: customerPolicyId,
            riders,
            status: "ACTIVE",
          })
        );
      } else {
        dispatch(
          fetchLifeInsuranceRidersSuccess(
            defaultLifeInsuranceRidersState["data"]
          )
        );
      }
    } catch (err: any) {
      dispatch(
        fetchLifeInsuranceRidersFailed("Something went to be wrong!")
      );
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        })
      );
    }
  };

export const addLifeInsuranceRidersAsync =
  (
    data: { customer_id: number; customer_policy_id: number; data: Omit<ILifeInsuranceRiders["riders"][number], "key">[] },
    onCallback: (isSuccess: boolean) => void
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      dispatch(saveLoaderProgress());
      await api.post(`/policy/edit-life-policy-riders`, {
        ...data,
      });
      dispatch(
        showMessage({
          type: "success",
          message: "Riders saved successfully!",
          displayAs: "snackbar",
        })
      );
      onCallback(true);
    } catch (err: any) {
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        })
      );
      onCallback(false);
    } finally {
      dispatch(saveLoaderCompleted());
    }
  };
